"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfGetPropertiesResponseDto = instanceOfGetPropertiesResponseDto;
exports.GetPropertiesResponseDtoFromJSON = GetPropertiesResponseDtoFromJSON;
exports.GetPropertiesResponseDtoFromJSONTyped = GetPropertiesResponseDtoFromJSONTyped;
exports.GetPropertiesResponseDtoToJSON = GetPropertiesResponseDtoToJSON;
exports.GetPropertiesResponseDtoToJSONTyped = GetPropertiesResponseDtoToJSONTyped;
var GetPropertiesResponseDataDto_1 = require("./GetPropertiesResponseDataDto");
/**
 * Check if a given object implements the GetPropertiesResponseDto interface.
 */
function instanceOfGetPropertiesResponseDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function GetPropertiesResponseDtoFromJSON(json) {
    return GetPropertiesResponseDtoFromJSONTyped(json, false);
}
function GetPropertiesResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (0, GetPropertiesResponseDataDto_1.GetPropertiesResponseDataDtoFromJSON)(json['data']),
        'error': json['error'] == null ? undefined : json['error'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function GetPropertiesResponseDtoToJSON(json) {
    return GetPropertiesResponseDtoToJSONTyped(json, false);
}
function GetPropertiesResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': (0, GetPropertiesResponseDataDto_1.GetPropertiesResponseDataDtoToJSON)(value['data']),
        'error': value['error'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
